/* eslint-disable no-restricted-globals */
/* eslint-disable no-restricted-properties */
/* eslint-disable no-restricted-syntax */
/* eslint-disable class-methods-use-this */
import manufacturies from '../assets/manufacturies';
import { toBarNumber } from '../../utils/pressure';
import styles from './styles';

const { ptBR } = require('date-fns/locale');
const { format } = require('date-fns');

const INITIAL_STATE = {
  inspection: {
    currentPMTA: '',
    dateToExternalInsp: '',
    dateToInternalInsp: '',
    tag: '',
    tapNumber: '', //
    reportNumber: '', //
    createdAt: '', //
    art: '', //
  },
  client: {
    companyName: '',
    address: '',
    city: '',
    uf: '',
    cnpj: '',
  },
  manometer: {
    id: 0,
    seal: ''
  },
  valve: {
    id: 0,
    seal: ''
  },
  equipment: {
    vasselPosition: '',
    vesselMaterial: '',
    fluid: '',
    fluidClass: '',
    location: '',
  },
  namePlate: {
    manufacturer: 1,
    yearOfManufacture: '',
    model: '',
    serialNumber: '',
    volume: '',
    category: '', // Salvar do resultado do laudo
    riskGroup: '', // Salvar do resultado do laudo
    vesselFunction: '',
    operatingPressure: { bar: '' },
    hidrostatico: { bar: '' },
    constructionCode: 'ASME Seção VIII Divisão 1/1999',
    efficiencyCoefficientCover: '1.0',
    efficiencyCoefficientSide: '0.7',
  },
};

class RecordBookPDF {
  constructor(inspection = INITIAL_STATE) {
    this.inspection = inspection.inspection;
    this.manometer = inspection.manometer || INITIAL_STATE.manometer;
    this.valve = inspection.valve || INITIAL_STATE.valve;
    this.namePlate = inspection.namePlate || INITIAL_STATE.namePlate;
    this.equipment = inspection.equipment || INITIAL_STATE.equipment;
    this.client = inspection.client || INITIAL_STATE.client;
    this.vesselManufacture = this.resolveManufacturer(inspection);
  }

  /**
   * O app envia `namePlate.manufacturer` como objeto ({name, source, externalId}), então a
   * busca antiga pelo id na lista estática não encontrava nada e o bloco "Fabricante do Vaso
   * de Pressão" saía vazio/"desconhecido". A API passou a resolver o fabricante no banco e a
   * devolvê-lo em `vesselManufacturer`; a lista estática fica como fallback para respostas
   * antigas, e o objeto retornado nunca é nulo (o PDF acessa os campos direto).
   */
  resolveManufacturer(inspection) {
    const fallback = {
      name: 'Fabricante Desconhecido',
      street: '',
      number: '',
      neighborhood: '',
      city: '',
      uf: '',
      country: '',
      cep: '',
      phone: '',
    };

    const resolved = (inspection && inspection.vesselManufacturer) || null;
    if (resolved && resolved.name) {
      return { ...fallback, ...resolved };
    }

    const rawManufacturer = this.namePlate.manufacturer;
    const manufacturerId = rawManufacturer && typeof rawManufacturer === 'object'
      ? rawManufacturer.externalId || rawManufacturer.id
      : rawManufacturer;
    const manufacturerName = this.namePlate.manufacturerName
      || (rawManufacturer && typeof rawManufacturer === 'object' ? rawManufacturer.name : '')
      || (typeof rawManufacturer === 'string' ? rawManufacturer : '');

    const fromAsset = manufacturies.find(
      // eslint-disable-next-line eqeqeq
      (manufacture) => manufacture.id == manufacturerId
        || `${manufacture.name}`.toLowerCase() === `${manufacturerName}`.toLowerCase(),
    );

    if (fromAsset) {
      return { ...fallback, ...fromAsset };
    }

    return manufacturerName ? { ...fallback, name: manufacturerName } : fallback;
  }

  /**
   * Coeficiente de eficiência de solda dos tampos. Havendo Tampo Tipo Reto, mostra também o
   * fator adimensional (N) usado no cálculo da PMTA, no formato "coeficiente/fator", igual ao
   * Quadro 3 do relatório de inspeção.
   */
  coverEfficiencyCoefficientText() {
    const coefficient = `${this.namePlate.efficiencyCoefficientCover || ''}`;

    const coverTypes = Array.isArray(this.equipment.coverTypes)
      ? this.equipment.coverTypes.filter(Boolean)
      : [this.equipment.coverType].filter(Boolean);

    const flatCover = coverTypes.find(
      (cover) => (typeof cover === 'string' ? cover : cover.type) === 'tampos_tipo_reto',
    );

    if (!flatCover) {
      return coefficient;
    }

    const dimensionlessFactor = (typeof flatCover === 'object' && flatCover.dimensionlessFactor)
      || this.equipment.dimensionlessFactor;

    return dimensionlessFactor ? `${coefficient}/${dimensionlessFactor}` : coefficient;
  }

  cmToPoint(cm) {
    const pol = cm * 0.393701;
    return pol * 72;
  }

  /** Junta as partes preenchidas do endereço, evitando " - - " quando algum campo falta. */
  joinParts(parts, separator) {
    const filled = parts
      .map((part) => `${part === undefined || part === null ? '' : part}`.trim())
      .filter(Boolean);

    return filled.length ? filled.join(separator) : ' -';
  }

  pageBreak() {
    return {
      text: '',
      pageBreak: 'after',
    };
  }

  getPdfContentEntries(pdfContent) {
    if (Array.isArray(pdfContent)) {
      return pdfContent;
    }

    if (typeof pdfContent !== 'string' || !pdfContent.trim()) {
      return [];
    }

    try {
      const parsedContent = JSON.parse(pdfContent);
      return Array.isArray(parsedContent) ? parsedContent : [];
    } catch (error) {
      return [];
    }
  }

  getEntriesContainingText(entries, searchText) {
    if (!Array.isArray(entries) || !searchText) {
      return [];
    }

    return entries.filter((entry) => JSON.stringify(entry).includes(searchText));
  }

  possuiAfericao(model) {
    try {
      return (model && model.id && parseInt(model.id) > 0)
        ? true
        : false;
    } catch (error) {
      return false;
    }
  }

  firstPage() {
    return [
      {
        table: {
          widths: ['100%'],
          body: [
            [
              {
                margin: [
                  this.cmToPoint(1.06),
                  this.cmToPoint(0.25),
                  this.cmToPoint(1.06),
                  this.cmToPoint(1.59),
                ],
                table: {
                  widths: ['100%'],
                  body: [
                    [
                      {
                        margin: [
                          this.cmToPoint(0.2),
                          this.cmToPoint(1.15),
                          this.cmToPoint(0.5),
                          this.cmToPoint(0.1),
                        ],
                        alignment: 'justify',
                        lineHeight: 2.25,
                        fontSize: 14,
                        border: [true, true, true, false], // left, top, right, bottom
                        text: [
                          `\u200B\t\t\tEste documento contém folhas numeradas de 01 a 50, e serve de registro de segurança de Vaso de Pressão ${this.inspection.tag}, Número TAP: ${this.inspection.tapNumber}, `,
                          'especificado',
                          ` neste livro, da empresa ${this.client.companyName}, estabelecida à ${this.client.address}, cidade de ${this.client.city} – ${this.client.uf}, sob o CNPJ:  ${this.client.cnpj}, em atendimento à Norma Regulamentadora 13 (NR 13), alterada pela Portaria MTP nº 4.219, de 20 de dezembro de 2022.`,
                        ],
                      },
                    ],
                    [
                      {
                        border: [true, false, true, false], // left, top, right, bottom
                        text: `Divinópolis, ${format(
                          new Date(this.inspection.createdAt),
                          'dd MMMM yyyy',
                          {
                            locale: ptBR,
                          },
                        )}`,
                        alignment: 'right',
                        fontSize: 12,
                        margin: [0, 0, this.cmToPoint(0.5), 0],
                      },
                    ],
                    [
                      {
                        text: 'Fabricante do Vaso de Pressão',
                        border: [true, false, true, false], // left, top, right, bottom
                        alignment: 'center',
                        fontSize: 12,
                        bold: true,
                        margin: [0, this.cmToPoint(4.5), 0, this.cmToPoint(0.3)],
                      },
                    ],
                    [
                      {
                        border: [true, false, true, true], // left, top, right, bottom
                        lineHeight: 1.25,
                        margin: [this.cmToPoint(0.2), 0, 0, this.cmToPoint(3.5)],
                        stack: [
                          {
                            text: [
                              {
                                text: 'Empresa: ',
                                bold: true,
                              },
                              {
                                text: ` ${this.vesselManufacture.name}`,
                              },
                            ],
                          },
                          {
                            text: [
                              {
                                text: 'Endereço: ',
                                bold: true,
                              },
                              {
                                text: ` ${this.joinParts(
                                  [this.vesselManufacture.street, this.vesselManufacture.number],
                                  ', ',
                                )}`,
                              },
                            ],
                          },
                          {
                            text: this.joinParts(
                              [
                                this.vesselManufacture.neighborhood,
                                this.vesselManufacture.city,
                                this.vesselManufacture.uf,
                                this.vesselManufacture.country,
                              ],
                              ' - ',
                            ),
                          },
                          {
                            text: [
                              {
                                text: 'CEP: ',
                                bold: true,
                              },
                              {
                                text: ` ${this.vesselManufacture.cep || ' -'} - `,
                              },
                              {
                                text: 'Telefone: ',
                                bold: true,
                              },
                              {
                                text: ` ${this.vesselManufacture.phone || ' -'} `,
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  ],
                },
              },
            ],
          ],
        },
      },
    ];
  }

  secondPage() {
    return [
      {
        table: {
          widths: ['100%'],
          body: [
            [
              {
                margin: [
                  this.cmToPoint(1.06),
                  this.cmToPoint(0.25),
                  this.cmToPoint(1.06),
                  this.cmToPoint(1.59),
                ],
                table: {
                  widths: ['100%'],
                  body: [
                    [
                      {
                        margin: [0, this.cmToPoint(1.15), 0, this.cmToPoint(1.15)],
                        border: [true, true, true, false], // left, top, right, bottom
                        alignment: 'center',
                        fontSize: 18,
                        text: 'Caracterização Técnica do Vaso',
                      },
                    ],
                    [
                      {
                        margin: [this.cmToPoint(0.2), 0, 0, this.cmToPoint(12.5)],
                        lineHeight: 1.25,
                        border: [true, false, true, true], // left, top, right, bottom
                        stack: [
                          [
                            {
                              text: [
                                {
                                  text: 'Nº DE SÉRIE:',
                                  bold: true,
                                },
                                {
                                  text: ` ${this.namePlate.serialNumber || 'Desconhecido'}`,
                                },
                              ],
                            },
                          ],
                          [
                            {
                              text: [
                                {
                                  text: 'DATA DE FABRICAÇÃO:',
                                  bold: true,
                                },
                                {
                                  text: ` ${this.namePlate.yearOfManufacture || 'Desconhecido'}`,
                                },
                              ],
                            },
                          ],
                          [
                            {
                              text: [
                                {
                                  text: 'CÓDIGO DE CONSTRUÇÃO:',
                                  bold: true,
                                },
                                {
                                  text: ` ${this.namePlate.constructionCode.split('/')[0]
                                    || 'Desconhecido'} `,
                                },
                                {
                                  text: ' EDIÇÃO:',
                                  bold: true,
                                },
                                {
                                  text: ` ${this.namePlate.constructionCode.split('/')[1]
                                    || 'Desconhecido'} `,
                                },
                              ],
                            },
                          ],
                          [
                            {
                              text: [
                                {
                                  text: ' PMTA ATUAL: ',
                                  bold: true,
                                },
                                {
                                  // inspeções antigas gravaram a PMTA com 3 casas; o
                                  // arredondamento aqui normaliza o valor exibido
                                  text: this.inspection.currentPMTA
                                    ? ` ${(this.inspection.currentPMTA / 10).toFixed(2)} [MPa] - ${
                                      parseFloat(this.inspection.currentPMTA).toFixed(2)
                                    } [bar]`
                                    : 'N/A',
                                },
                              ],
                            },
                          ],
                          [
                            {
                              text: [
                                {
                                  text: 'PTH DE FABRICAÇÃO: ',
                                  bold: true,
                                },
                                {
                                  text: (() => {
                                    const hidrostaticoBar = toBarNumber(this.namePlate.hidrostatico);
                                    return hidrostaticoBar !== null
                                      ? ` ${(hidrostaticoBar / 10).toFixed(2)} [MPa] - ${
                                        hidrostaticoBar.toFixed(2)
                                      } [bar]`
                                      : 'N/A';
                                  })(),
                                },
                              ],
                            },
                          ],
                          [
                            {
                              text: [
                                {
                                  text: 'MATERIAL DO CORPO DO VASO:',
                                  bold: true,
                                },
                                {
                                  text: ` ${this.equipment.vesselMaterial || 'Desconhecido'}`,
                                },
                              ],
                            },
                          ],
                          [
                            {
                              text: [
                                {
                                  text: 'MATERIAL DO TAMPO DO VASO:',
                                  bold: true,
                                },
                                {
                                  text: ` ${this.equipment.vesselMaterial || 'Desconhecido'}`,
                                },
                              ],
                            },
                          ],
                          [
                            {
                              text: [
                                {
                                  text: 'EFICIÊNCIA DE SOLDA - ',
                                  bold: true,
                                },
                                {
                                  text: 'Tampos:',
                                  italic: true,
                                  bold: true,
                                },
                                {
                                  text: ` ${this.coverEfficiencyCoefficientText()}`,
                                },
                                {
                                  text: ' Costado:',
                                  italic: true,
                                  bold: true,
                                },
                                {
                                  text: ` ${this.namePlate.efficiencyCoefficientSide}`,
                                },
                              ],
                            },
                          ],
                          [
                            {
                              text: [
                                {
                                  text: 'TIPO DO FLUÍDO:',
                                  bold: true,
                                },
                                {
                                  text: ` ${this.equipment.fluid || 'Desconhecido'}`,
                                },
                              ],
                            },
                          ],
                          [
                            {
                              text: [
                                {
                                  text: 'GRUPO DE RISCO:',
                                  bold: true,
                                },
                                {
                                  text: ` ${this.namePlate.riskGroup || 'Desconhecido'}`,
                                },
                              ],
                            },
                          ],
                          [
                            {
                              text: [
                                {
                                  text: 'CATEGORIA:',
                                  bold: true,
                                },
                                {
                                  text: ` ${this.namePlate.category || 'Desconhecida'}`,
                                },
                              ],
                            },
                          ],
                          [
                            {
                              text: [
                                {
                                  text: 'CLASSE DO FLUÍDO:',
                                  bold: true,
                                },
                                {
                                  text: ` ${this.equipment.fluidClass || 'Desconhecido'}`,
                                },
                              ],
                            },
                          ],
                          [
                            {
                              text: [
                                {
                                  text: 'VOLUME:',
                                  bold: true,
                                },
                                {
                                  text: ` ${this.namePlate.volume || 'N/A'} litros`,
                                },
                              ],
                            },
                          ],
                        ],
                      },
                    ],
                  ],
                },
              },
            ],
          ],
        },
      },
    ];
  }

  thirdPage() {
    const title = (this.inspection?.dateToInternalInsp && this.inspection?.dateToExternalInsp)
      ? 'Inspeção Periódica Interna e Externa'
      : (this.inspection?.dateToInternalInsp && !this.inspection?.dateToExternalInsp)
        ? 'Inspeção Periódica Interna'
        : (!this.inspection?.dateToInternalInsp && this.inspection?.dateToExternalInsp)
          ? 'Inspeção Periódica Externa'
          : 'Inspeção Periódica';

    const complemento = (this.inspection?.dateToInternalInsp && this.inspection?.dateToExternalInsp)
      ? 'interna e externa'
      : (this.inspection?.dateToInternalInsp && !this.inspection?.dateToExternalInsp)
        ? 'interna'
        : (!this.inspection?.dateToInternalInsp && this.inspection?.dateToExternalInsp)
          ? 'externa'
          : '';

    const possuiAfericaoManometro = this.possuiAfericao(this.manometer);
    const possuiAfericaoValvula = this.possuiAfericao(this.valve);

    const justificativa = (possuiAfericaoManometro && possuiAfericaoValvula)
      ? 'juntamente da calibração/aferição da válvula de segurança e do manômetro, '
      : possuiAfericaoManometro
        ? 'juntamente da calibração/aferição do manômetro, '
        : possuiAfericaoValvula
          ? 'juntamente da calibração/aferição da válvula de segurança, '
          : '';
          
    return [
      {
        table: {
          widths: ['100%'],
          body: [
            [
              {
                margin: [
                  this.cmToPoint(1.06),
                  this.cmToPoint(0.25),
                  this.cmToPoint(1.06),
                  this.cmToPoint(1.59),
                ],
                table: {
                  widths: ['100%'],
                  body: [
                    [
                      {
                        margin: [0, this.cmToPoint(1.15), 0, 0],
                        border: [true, true, true, false], // left, top, right, bottom
                        alignment: 'center',
                        fontSize: 16,
                        bold: true,
                        text: title,
                      },
                    ],
                    [
                      {
                        margin: [
                          this.cmToPoint(0.2),
                          this.cmToPoint(0.8),
                          this.cmToPoint(0.5),
                          this.cmToPoint(1.15),
                        ],
                        border: [true, false, true, false], // left, top, right, bottom
                        alignment: 'justify',
                        lineHeight: 1.25,
                        fontSize: 12,
                        text: [
                          `Em ${format(
                            new Date(this.inspection.createdAt),
                            'dd/MM/yyy',
                          )}, executou-se inspeção de segurança ${complemento} periódicas, ${justificativa}conforme descrito no Relatório Nº ${this
                            .inspection.reportNumber
                            || '00/00'}, constante neste Databook, pelo `,
                          'profissional',
                          ` legalmente habilitado (PLH) Fernando Guimarães de Sousa - CREA-MG 171919/D. Pela evidência de Teste Hidrostático anterior e dadas as boas condições do vaso, o TH foi desaconselhado pelo `,
                          'profissional, ',
                          `conforme `,
                          'especificado',
                          ` no referido Relatório. Sendo que o equipamento foi liberado para operação com as recomendações contidas no relatório em referência, que faz parte integrante deste registro. Esta inspeção faz parte da página _____ deste Registro de Segurança. `,
                        ],
                      },
                    ],
                    [
                      {
                        margin: [this.cmToPoint(0.2), 0, 0, this.cmToPoint(14)],
                        border: [true, false, true, true], // left, top, right, bottom
                        fontSize: 12,
                        text: [
                          { text: 'ART:', bold: true },
                          {
                            text: ` ${this.inspection.art || '000000000000'}`,
                          },
                        ],
                      },
                    ],
                  ],
                },
              },
            ],
          ],
        },
      },
    ];
  }

  content() {
    return [
      this.firstPage(),
      this.pageBreak(),

      this.secondPage(),
      this.pageBreak(),

      this.thirdPage(),
    ];
  }

  /**
   * CONSTRUCTOR
   */
  pdfMaker() {
    return {
      pageSize: 'A4',
      // [left,top,right,botton]
      pageMargins: [this.cmToPoint(1), this.cmToPoint(0.8), this.cmToPoint(1), this.cmToPoint(0)],
      defaultStyle: {
        fontSize: 12,
        // Disable ligatures (fi/fl) while keeping the same font and plain text.
        fontFeatures: {
          liga: false,
          clig: false,
        },
      },
      content: this.content(),
      styles,
    };
  }
}

export default RecordBookPDF;
